(function (angular) {

  angular.module("alk.forms", [
    "alk.authentication",
    "alk.services"
  ]);

})(window.angular);

require("./login/login.directive.js");
require("./forgot/forgotPassword.directive.js");
require("./change-password/changePasswordController.js");
require("./partner-account-select/partnerAccountSelect.directive.js");
require("./partner-account-select/partnerAccountSelectStyles.less");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-forms/module.js